import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { map, filter, switchMap } from 'rxjs/operators';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { unitConversion } from '@ordersnproducts/modules/order-builder/modules/specification/helpers/unit-conversion.helper';
import { getOneClickJobsiteSalesArea } from '../../selectors/one-click-jobsites.selector';
import { getOneClickUnitsSelected } from '../../selectors/one-click-units.selector';

export namespace OneClickMaximumCapacityProvider {
  export abstract class MaximumCapacityBase<T> extends BaseAsyncValue<T> {
    public unitSubject = new Subject();
    protected unboxSalesArea() {
      return this.store.select(getOneClickJobsiteSalesArea).pipe(
        switchMap((jobsiteSalesArea) => {
          return this.store.select(getOneClickUnitsSelected).pipe(
            map((selectecUnit) => {
              const selectedUnit = selectecUnit;
              return { jobsiteSalesArea, selectedUnit };
            }),
            filter(({ selectedUnit }) => !!selectedUnit),
          );
        }),
      );
    }
  }
  export class MaxCapacity extends MaximumCapacityBase<number> {
    getValue(): Observable<number> {
      return this.unitSubject.pipe(
        switchMap(() => this.unboxSalesArea()),
        map(({ jobsiteSalesArea, selectedUnit }) => {
          return unitConversion(selectedUnit, jobsiteSalesArea.maximumLot.amount);
        }),
      );
    }
  }

  export class Message extends MaximumCapacityBase<string> {
    getValue(): Observable<string> {
      const translate: TranslateService = this.injector.get(TranslateService);
      return this.unitSubject.pipe(
        switchMap(() => this.unboxSalesArea()),
        map(({ jobsiteSalesArea, selectedUnit }) => {
          return `${translate.instant('views.specifications.maximum_capacity')}: ${unitConversion(
            selectedUnit,
            jobsiteSalesArea.maximumLot.amount,
          )} ${selectedUnit.alternativeUnit.unitCode}`;
        }),
      );
    }
  }
}
